import { useTranslation } from 'react-i18next'
import useNotifications from '../../hooks/useNotifications'
import { getPersonCount } from '../../services/treeService'

export default function usePersonCount(treeId, setTree) {
  const { t } = useTranslation()
  const { error } = useNotifications()

  const fetchPersonCount = async () => {
    await getPersonCount(treeId)
      .then((personsCountResponse) => {
        setTree((prevState) => {
          // ensure order remains the same, regardless of which response comes first
          const treeWithoutGroupsState =
            prevState && Object.fromEntries(Object.entries(prevState).filter(([key]) => key !== 'groups'))
          return {
            ...treeWithoutGroupsState,
            personCount: personsCountResponse.data,
            groups: prevState?.groups,
          }
        })
      })
      .catch((err) => {
        error(
          `${t('tree.error.personCount', 'Error getting persons count for tree')} ${treeId}: ${err.message || ''}`,
          err
        )
      })
  }

  return { fetchPersonCount }
}
